var _a;
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
export var routerMiddleware = (_a = createReduxHistoryContext({
    history: createBrowserHistory(),
    savePreviousLocations: 1,
}), _a.routerMiddleware), createReduxHistory = _a.createReduxHistory, routerReducer = _a.routerReducer;
